export function keywordMatch(searchString: string, targetString: string) {
    const keywords = searchString.toLowerCase().split(' ');
    const tsLower = targetString.toLowerCase();
    return keywords.every(kw => tsLower.includes(kw));
}